import React from 'react';

const ReferenceCitation = (): JSX.Element => (
  <svg viewBox="8 6 14 18">
    <path d="M20,6 L10,6 C8.9,6 8.01,6.9 8.01,8 L8,24 L15,21 L22,24 L22,8 C22,6.9 21.1,6 20,6 L20,6 Z" />
  </svg>
);

export default ReferenceCitation;
